// ============================================================
// ActorAvatar.tsx
// Renders the avatar of an activity/audit entry's ACTOR. Audit entries
// snapshot actorEmail but also carry actorUserId, so we look the actor
// up in the shared firmUsers slice for their real (current) avatar, and
// fall back to a styled initial from the snapshot email when they're not
// found — a deleted user, or a NON-ADMIN whose firmUsers slice is empty
// (listUsers is admin-only). So there is ALWAYS an avatar.
//
// NON-ADMIN NOTE: non-admins can't load firmUsers (403 → empty slice),
// so for them every actor uses the email-initial fallback rather than the
// actor's real chosen avatar. Acceptable for v1; making real avatars work
// for non-admins would need the audit endpoints to return the actor's
// avatar per entry (not doing that now).
//
// Subscribes to the SPECIFIC user (not the function) so the avatar
// upgrades from the email fallback to the real avatar once the slice
// loads. The caller is responsible for triggering loadFirmUsers() once
// on its own mount (load-once, graceful for non-admins).
// ============================================================
import React from 'react'
import UserAvatar from './UserAvatar'

interface ActorAvatarProps {
  actorUserId: string
  actorEmail: string
  size?: 'sm' | 'md' | 'lg'
}

// ★ Now the shared UserAvatar (the app-wide rule — it also resolves YOU from
// your own account, which the firm-users-only lookup here used to miss). A
// user no longer in the firm list falls back to the snapshot email's initial.
const ActorAvatar: React.FC<ActorAvatarProps> = ({ actorUserId, actorEmail, size = 'sm' }) => (
  <UserAvatar userId={actorUserId} fallbackName={actorEmail} size={size} title={false} />
)

export default ActorAvatar
